export default {
  "click-outside": "_click-outside_5ktnt7",
  "menu": "_menu_5ktnt7",
  "menu-toggle": "_menu-toggle_5ktnt7",
  "organization-list": "_organization-list_5ktnt7",
  "divider": "_divider_5ktnt7",
  "in-app-link": "_in-app-link_5ktnt7",
  "end-migration": "_end-migration_5ktnt7"
};
